module.exports = function loadURLBundle(bundle) {
  return Promise.resolve(bundle);
};
